module.exports = __webpack_public_path__ + "static/scale-model-of-tia-stephanie-tours-in-ann-arbor-michigan-d1c4bc6ebd10371493f775626f0f6f37.png";